import { AdminReturnWorkflowStatus } from "@redotech/redo-model/temporal/workflow-status";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import z from "zod/v4";

export const getWorkflowStatusesBulk = {
  name: "getWorkflowStatusesBulk" as const,
  input: z.object({ returnIds: z.array(zExt.objectId()) }),
  output: z.object({
    statuses: z.array(
      z.object({
        _id: zExt.objectId(),
        teamId: zExt.objectId(),
        returnId: zExt.objectId(),
        workflowId: z.string(),
        workflowType: z.string(),
        status: createEnum(AdminReturnWorkflowStatus),
        message: z.string().nullish(),
        lastModifiedBy: z.string(),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
};
